import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

@autobind
class WorkLoading extends Component {
  render () {
    return (
      <div className='workMedia'></div>
    )
  }
}

export default WorkLoading



// WEBPACK FOOTER //
// ./components/work/WorkLoading.js